import type { IssueGridParameters } from './types';
import { DEFAULT_SORT } from '../../models/sortModel';

export const DEFAULT_PARAMETERS: IssueGridParameters = {
  offset: 0,
  deleted: false,
  search: '',
  sort: DEFAULT_SORT,
};
